import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';

@Component({
  selector: 'app-finance-team-dashboard',
  templateUrl: './finance-team-dashboard.component.html',
  styleUrls: ['./finance-team-dashboard.component.css']
})
export class FinanceTeamDashboardComponent implements OnInit {

  duepage=1;
  duecurrentPage = 1;
  pageSize: number;
  
  overduepage=1;
  overduecurrentPage = 1;
  
  itemsPerPage = 5;
  duetotalrecord:number;
  overduetotalrecord:number;
  submitted = false;
  message: string;	
  invoice = new Invoice();
  dueinvoices: Invoice[];
  overdueinvoices: Invoice[];
  dashboardcounts :any = {};

  dataSource: Object;
  graphdata : any = [];

  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
    ) { }

  ngOnInit() {
    this.getDueInvoices();
    this.getOverDueInvoices();
    this.getDashboardCountsFinance();
    this.GetDasboardgraphData();
  }

  getDueInvoices() {
    return this.invoiceService.getDueInvoices()
               .subscribe(
                invoices => {
                  this.dueinvoices = invoices;
				          this.duetotalrecord =this.dueinvoices.length;
                 }
                );
 }
 getDashboardCountsFinance() {
  return this.invoiceService.getDashboardCountsFinance()
             .subscribe(
              counts => {
                (this.dashboardcounts) = counts[0];
               }
              );
}
 getOverDueInvoices() {
  return this.invoiceService.getOverDueInvoices()
             .subscribe(
              invoices => {
                this.overdueinvoices = invoices;
                this.overduetotalrecord =this.overdueinvoices.length;
               }
              );
}

  public dueonPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }
  public overdueonPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  public duechangePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }
  public overduechangePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }

  GetDasboardgraphData() {
   
    return this.invoiceService.GetDasboardgraphData()
               .subscribe(
                datalist => {                 
                  this.graphdata = datalist;
				   console.log(this.graphdata);
				  // var labels = this.objectToArray(this.graphdata, 'FilterType');
			      // var data = this.objectToArray(this.graphdata, 'Amount');
				   this.dataSource = {
			  chart: {
				  "caption": "Expenses",
				  //"subCaption": "In MMbbl = One Million barrels",
				 // "xAxisName": "Country",
				  //"yAxisName": "Reserves (MMbbl)",
				  //"numberSuffix": "K",
				  //"theme": "fusion",
			  },
			  // Chart Data
			  "data": this.graphdata,
			  /*[{
				  "label": "January",
				  "value": "62"
			  },{
				  "label": "Feburary",
				  "value": "60"
			  },{
				  "label": "March",
				  "value": "80"
			  },{
				  "label": "April",
				  "value": "80"
			  },{
				  "label": "May",
				  "value": "56"
			  },{
				  "label": "June",
				  "value": "54"
			  }, {
				  "label": "July",
				  "value": "40"
			  }]
			  */
		  }; // end of this.dataSource
         
                 }
                );
 }
 

}
